import type Contest from '~/types/contest'
import type { Influencer, StatsV3Influencer } from '~/types/influencer'
import type { MaybeRefOrGetter } from 'vue'

export function useCuratorContestsInfos(
  reactiveInfluencer: MaybeRefOrGetter<Influencer | StatsV3Influencer>,
) {
  const influencer = toValue(reactiveInfluencer)
  const daysLeft = computed<number | undefined>(() => {
    if (!curatorIsContest(influencer)) return undefined

    const now = new Date().getTime()
    const end = new Date(influencer.contest.date_expired || 0).getTime()
    const diff = end - now
    const m = diff / 1000 / 60
    const h = m / 60

    return Number((h / 24).toFixed())
  })

  /**
   * @deprecated Opt in for the typeguard curatorIsContest.
   */
  const isContest = computed<boolean>(() => curatorIsContest(influencer))

  type ContestInfluencer<T extends Influencer | StatsV3Influencer> = {
    contest: Contest
  } & Omit<T, 'contest'>
  function curatorIsContest<T extends Influencer | StatsV3Influencer>(
    curator: T,
    // @ts-expect-error
  ): curator is ContestInfluencer<T> {
    return !!curator?.contest
  }

  return {
    curatorIsContest,
    isContest,
    daysLeft,
  }
}
